import { memoize } from 'lodash';
import { createSelector } from 'reselect';

import { LoanChangesHistoryEntityType } from 'constants/loanChanges';
import { fillRowsWithPendingChangesFields } from 'utils/pendingChanges';

import {
  selectEntitiesChangedPropsByIds,
  selectEntityLoanChangesByEntityTypeName,
} from 'store/loanApplications/selectors';

import { selectUnderwriting } from './underwriting.selectors';

const selectDocumentExpirationDates = createSelector(
  selectUnderwriting,
  ({ documentExpirationDates }) => documentExpirationDates,
);

const selectDocumentExpirationDatesPendingChanges = createSelector(
  state => state,
  state => {
    const documentExpirationDatesPendingChangesIds = Object.keys(
      selectEntityLoanChangesByEntityTypeName(
        LoanChangesHistoryEntityType.DOCUMENT_EXPIRATION_DATE,
      )(state),
    );
    const documentExpirationDatesPendingChanges = selectEntitiesChangedPropsByIds(
      documentExpirationDatesPendingChangesIds,
    )(state);

    return documentExpirationDatesPendingChanges;
  },
);

export const selectDocumentExpirationDatePendingChangesById = id =>
  createSelector(
    selectDocumentExpirationDatesPendingChanges,
    documentExpirationDatesPendingChanges => documentExpirationDatesPendingChanges[id],
  );

export const selectPreparedDocumentExpirationDates = createSelector(
  [selectDocumentExpirationDates, selectDocumentExpirationDatesPendingChanges],
  (documentExpirationDates, documentExpirationDatesPendingChanges) =>
    fillRowsWithPendingChangesFields({
      data: documentExpirationDates,
      pendingChanges: documentExpirationDatesPendingChanges,
      dataPrimaryKey: 'id',
    }),
);

export const selectDocumentExpirationDatesBusyTitles = memoize(id =>
  createSelector(selectDocumentExpirationDates, documentExpirationDates =>
    documentExpirationDates.reduce((acc, item) => {
      if (item.id !== id) {
        acc.push(item.title);
      }

      return acc;
    }, []),
  ),
);
